// ["MainLayout", "Component"]
// TEMPORARY: Maintenance holding page - revert this file to restore normal site
import MaintenancePage_Component from "./MaintenancePage_Component.jsx";

/**
 * Temporarily replaced with maintenance holding page.
 * Revert this file to restore normal routing.
 * @returns {JSX.Element} Maintenance holding page.
 */
export default function MainLayout_Component() {
  return <MaintenancePage_Component />;
}
